import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SOWSidebar = ({ sows, selectedSow, onSelectSow }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{
      width: "200px", flexShrink: 0,
      borderRight: `1px solid ${t.border2}`,
      display: "flex", flexDirection: "column",
      overflowY: "auto",
    }}>

      {/* Header */}
      <Box sx={{ padding: "12px 16px 8px", flexShrink: 0 }}>
        <Typography sx={{
          fontFamily: "'DM Mono', monospace",
          fontSize: "9px", letterSpacing: "0.14em",
          textTransform: "uppercase", color: t.text3,
        }}>
          SOWs
        </Typography>
      </Box>


      {/* Individual SOWs */}
      {sows.map((sow) => (
        <SidebarItem
          key={sow.sowId}
          label={sow.sowName}
          active={selectedSow === sow.sowId}
          onClick={() => onSelectSow(sow.sowId)}
          t={t}
        />
      ))}

      <SidebarItem
        label="All SOWs"
        active={selectedSow === null}
        onClick={() => onSelectSow(null)}
        t={t}
      />
    </Box>
  );
};

const SidebarItem = ({ label, active, onClick, t }) => (
  <Box
    onClick={onClick}
    sx={{
      padding: "8px 16px", cursor: "pointer",
      borderLeft: active ? `2px solid ${t.accent}` : "2px solid transparent",
      background: active ? t.accent2 : "transparent",
      transition: "all 0.15s",
      "&:hover": { background: active ? t.accent2 : t.surface2 },
    }}
  >
    <Typography sx={{
      fontFamily: "'Inter', sans-serif",
      fontSize: "12px",
      fontWeight: active ? 600 : 400,
      color: active ? t.accent : t.text2,
      whiteSpace: "nowrap",
      overflow: "hidden", textOverflow: "ellipsis",
      transition: "color 0.15s",
    }}>
      {label}
    </Typography>
  </Box>
);

export default SOWSidebar;